import { initializeApp } from 'firebase/app'
import { browserLocalPersistence, getAuth, onAuthStateChanged, setPersistence } from 'firebase/auth'
import store from '@/store/store'

export const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_PROJECT + '.firebaseapp.com',
  databaseURL: `https://${process.env.FIREBASE_PROJECT}.firebaseio.com`,
  projectId: process.env.FIREBASE_PROJECT,
  storageBucket: process.env.FIREBASE_PROJECT + '.appspot.com',
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID
}

export async function getPersistentAuth () {
  const auth = getAuth()
  await setPersistence(auth, browserLocalPersistence)
  return auth
}

export default function install (Vue, setupOptions = {}) {
  const app = initializeApp(firebaseConfig)
  onAuthStateChanged(getAuth(), (user) => {
    store.commit('auth/setEmail', user ? user.email : null)
  })
  Vue.prototype.$firebase = app
  Vue.prototype.$getAuth = getPersistentAuth
}
